import React from 'react'
import styled from 'styled-components'

const Mission = () => {
  return (
    <Wrapper>
      <h1>
        We are building a house in France with Maisons de la Côte Atlantique
        (MCA) in France
      </h1>
      <br />
      We live in Germany. This is how it's going.
      <p class="faint">
        We share our experiences about the house construction, finding a credit
        company in France, a terrain etc. We share tips and talk about road
        blocks and obstacles we encounter.
      </p>
      <div className="underline"></div>
   
    </Wrapper>
  )
}

export default Mission

const Wrapper = styled.article`
  text-align: center;
  margin: 2rem 0;
  h1 {
    font-size: 1.5rem;
  }
  .faint {
    margin-right: auto;
    margin-left:auto;
    color: #ccc;
    font-size: 0.8em;
    font-style: italic;
    max-width: 60%;
    text-align:center;
  }
`
